import { Carousel2 } from '@intigral/ui';
import h, { getCountry } from '../../helpers/common';
import f from '../../helpers/formatter';
import f2 from '../../helpers/formatter2';
import { __ } from '../../translations';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import { Poster } from '@intigral/shared/components/Poster';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import useLanguage from '../../hooks/useLanguage';
import { DetailedPoster } from '@intigral/shared';
import { useConfigurationSections } from '../../hooks/useConfiguration';
import { ITransformLinear } from '../../interfaces/TransformResponse';
import url from '../../helpers/url';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showUpgradedModal } from '../../store/reducers/generalConfigurationSlice';
import moment from 'moment';
import { setSession } from '@intigral/utils/lib/browser-storage/localStorage';

type LiveTvTrendingProps = {
    isLoading?: boolean;
    content: ITransformLinear[];
    meta: any;
    params: any;
    carousel?: Carousel;
    data?: any;
};

export const LiveTvTrending = ({ isLoading, content, meta, params, carousel }: LiveTvTrendingProps) => {
    const language = useLanguage();
    const countryCode = getCountry().toLowerCase();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { autoTrailerCarousel } = useConfigurationSections();
    const autoTrailerCarouselConfiguration = autoTrailerCarousel;
    const countryName = __(`country_${countryCode}`);
    const componentTitle = `${__(carousel.title_resource_key) ?? ''}`.replace(/\{(.*?)\}/g, '<$1>');
    const formattedTitle = f2.getPlaceholderValue(componentTitle, { X: countryName });

    // unique class name to address the swiper pagination
    const pagingId = `component-${Math.random().toString(36).slice(2, 11)}`;
    const paginationClass = `pagination-${pagingId}`;
    const maxItems = carousel?.maxItems;
    const contents = maxItems && content?.length > maxItems ? content?.slice(0, maxItems) : content;

    const handleNavigateLiveTv = (item) => {
        if (item?.isLock) {
            dispatch(showUpgradedModal(true));
        } else {
            setSession('noAds', 'true');
            navigate(
                url.route('livetv', {
                    id: btoa(item?.Id),
                    startDate: btoa(item?.startTime),
                })
            );
            const redirectUrl = url.route('livetv', {
                id: btoa(item.Id),
                stationId: btoa(item.stationId),
                listingId: btoa(item.listingId),
                startDate: btoa(item?.startTime),
            });
            navigate(redirectUrl);
        }
    };

    return (
        <div className="container full-width" data-test-id={carousel?.id}>
            {contents && contents?.length ? (
                <SectionHeaderWithPagination
                    title={formattedTitle}
                    className={`${paginationClass}`}
                    seeAllText={__('home_carousel_see_all')}
                    seeAllUrl={f.getComponentSeeAllLink(meta, params, null, carousel, formattedTitle) as string}
                    isLoading={isLoading}
                />
            ) : (
                <SectionHeaderWithPagination isLoading={isLoading} />
            )}

            <Carousel2
                isLoading={isLoading}
                swiperSettings={{
                    slidesPerGroup: 1,
                    slidesPerView: 1.5,
                    breakpoints: {
                        560: {
                            slidesPerView: 2,
                        },
                        1212: {
                            slidesPerView: 2.5,
                        },
                        1560: {
                            slidesPerView: 3,
                        },
                        2560: {
                            slidesPerView: 3.5,
                        },
                    },
                    pagination: {
                        el: '.paging',
                        clickable: true,
                    },
                }}
                dir={language == 'ar' ? 'rtl' : 'ltr'}
                top10={true}
            >
                {isLoading ? (
                    <Poster isLoading />
                ) : (
                    contents?.map((item: any, index) => {
                        return (
                            <DetailedPoster
                                onClick={() => handleNavigateLiveTv(item)}
                                key={`${index}`}
                                picture={
                                    h.getImagizerUrl(
                                        item?.image_landscape,
                                        Number(autoTrailerCarouselConfiguration?.landscape_image_width) || 617,
                                        Number(autoTrailerCarouselConfiguration?.landscape_image_height) || 348,
                                        Number(autoTrailerCarouselConfiguration?.portait_image_quality) || 100
                                    ) || null
                                }
                                heading={item.title}
                                channelLogo={item.channelLogo}
                                info={item.info}
                                locked={item?.isLock}
                            />
                        );
                    })
                )}
            </Carousel2>
        </div>
    );
};
